import React, { useState, createContext, useContext, useEffect } from "react";
import { delSessionFunc } from "../api/func/userFunc";

export const AuthContext = createContext({
  isLoggedIn: false,
  user: null,
  login: () => {},
  logout: () => {},
  setUser: () => {},
});

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState(null);

  // 페이지 로드 시 세션 확인
  useEffect(() => {
    const storedUser = sessionStorage.getItem("user");
    if (storedUser) {
      try {
        const userData = JSON.parse(storedUser);
        setUser(userData);
        setIsLoggedIn(true);
      } catch (error) {
        console.error("저장된 사용자 정보 파싱 오류:", error);
        sessionStorage.removeItem("user");
      }
    }
  }, []);

  const login = async (userData) => {
    console.log(`## login start ##`);
    sessionStorage.setItem("user", JSON.stringify(userData));
    setIsLoggedIn(true);
    setUser(userData);
    console.log(`## login end ##`);
  };

  // navigate 제거하고 순수하게 로그아웃 처리만
  const logout = async () => {
    console.log(`## logout start ##`);
    try {
      const storedUser = sessionStorage.getItem("user");
      if (storedUser) {
        const userData = JSON.parse(storedUser);
        await delSessionFunc(userData.phone_number);
      }
      sessionStorage.removeItem("user");
      setIsLoggedIn(false);
      setUser(null);
      console.log(`## logout end ##`);
    } catch (error) {
      console.error("Logout error:", error);
    }
  };

  return (
    <AuthContext.Provider
      value={{ isLoggedIn, user, login, logout, setIsLoggedIn, setUser }}
    >
      {children}
    </AuthContext.Provider>
  );
};